<template>
  <div
    v-show="isShowTip"
    class="vft-screen-orientation"
  >
    <div
      class="horizontal_close_btn"
      @click="closeTip"
    >
      <svg
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <!-- eslint-disable-next-line -->
        <path d="M8.00005 8.91923L11.076 11.9951L11.9952 11.0759L8.91929 7.99999L11.9952 4.92409L11.076 4.00485L8.00005 7.08075L4.92412 4.00482L4.00488 4.92406L7.08081 7.99999L4.00488 11.0759L4.92412 11.9952L8.00005 8.91923Z" fill="currentColor" fill-opacity="0.9"/>
      </svg>
    </div>
    <div class="horizontal_screen">
      <i class="icon_phone" />
      <p class="desc_txt">
        为了更好的体验，请使用{{ orientation == 'portrait' ? '横' : '竖' }}屏浏览
      </p>
    </div>
  </div>
</template>
<script>
import { create } from './orientation';

// 默认竖屏
const defaultOrientation = 'portrait';

export default {
  name: 'MagicUiOrientationTip',
  props: {
    customOrientation: {
      type: String,
      default: defaultOrientation,
      validator(value) {
        return ['landscape', 'portrait', 'all'].includes(value);
      },
    },
    detector: {
      type: String,
      default: 'resize',
      validator: v => ['resize', 'orientation', 'media'].includes(v),
    },
  },

  data() {
    return {
      orientation: '',
      isTipClosedByUser: false,
    };
  },

  computed: {
    // 是否显示屏幕方向提示
    isShowTip() {
      // 用户手动关闭了提示，不再显示
      if (this.isTipClosedByUser) {
        return false;
      }

      // 外部没传屏幕默认的方向，跟 defaultOrientation 进行判断
      // 如果不一致，则需要显示
      // 如果一致，则不显示
      if (!this.customOrientation) {
        return this.orientation !== defaultOrientation;
      }

      // 外部传了横竖屏都支持时，不显示
      if (this.customOrientation === 'all') {
        return false;
      }

      // 判断外部传的屏幕方向跟当前计算的是否一致
      // 如果不一致，则需要显示
      // 如果一致，则不显示
      return this.customOrientation !== this.orientation;
    },
  },

  created() {
    const detector = create(this.detector);
    // 首次检测
    this.orientation = detector.orientation;
    // 变化时，再次检测
    detector.onChange((orientation) => {
      this.orientation = orientation;
      return orientation;
    });
  },

  methods: {
    // 用户手动关闭，关闭后将不再展示
    closeTip() {
      this.isTipClosedByUser = true;
    },
  },
};
</script>

<style lang="scss">
@keyframes horizontalScreen {
  10% {
    transform: rotate(90deg);
    transform: rotate(90deg);
  }
  50%,
  60% {
    transform: rotate(0deg);
    transform: rotate(0deg);
  }
  90% {
    transform: rotate(90deg);
    transform: rotate(90deg);
  }
  100% {
    transform: rotate(90deg);
    transform: rotate(90deg);
  }
}
.vft-screen-orientation {
  position: fixed;
  z-index: 10001;
  height: 100%;
  width: 100%;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background: #000;
}
.vft-screen-orientation .horizontal_screen {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
.vft-screen-orientation .horizontal_screen .icon_phone {
  display: block;
  margin: 0 auto;
  background-image: url(//vm.gtimg.cn/tencentvideo/vstyle/mobile/vip/style/app_v2/img/common/icon_phone.png);
  background-repeat: repeat;
  background-size: 100%;
  width: 67px;
  height: 109px;
  transform: rotate(90deg);
  animation: horizontalScreen infinite 1.5s ease-in-out;
}
.vft-screen-orientation .horizontal_screen .desc_txt {
  font-size: 15px;
  color: #fff;
  line-height: 24px;
  text-align: center;
}
.vft-screen-orientation .horizontal_close_btn {
  color: #fff;
  margin: 10px;
  width: 0.2rem;
  height: 0.2rem;
  position: absolute;
  right: 0;
}
</style>
